let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3q19A")).then(() => parcelRequire('dizwu'));